<script>
import ApiNormaCsLink from '@src/api/entities/ApiNormaCsLink';
import { ROUTE_DOCUMENT } from '@src/routes';

const locationBaseUrl = `${location.protocol}//${location.host}${__BASE_URL__}`;

/**
 * Возвращает для HTML-элемента elem родительский элемент-ссылку (или сам elem,
 * если он является ссылкой) или значение null, если такой элемент отсутствует.
 *
 * Метод позволяет получать элементы-ссылки из iframe-ов в браузерах, которые
 * не поддерживают метод Element.closest().
 *
 * @param {Element} elem
 * @returns {HTMLAnchorElement|null}
 */
const getClosestLink = elem => {
  if (elem.closest) {
    return elem.closest('a');
  }
  while (elem.nodeName.toUpperCase() !== 'A' && (elem = elem.parentElement)) {
    // empty statement
  }
  return elem;
};

/**
 * @param {ApiNormaCsLink} link
 * @param {Route} currentRoute
 * @returns {Object}
 */
const makeDocumentRoute = (link, currentRoute) => {
  let paramView =
    link.documentView != 'text' ? link.documentView :
    link.isInternal && currentRoute.name === ROUTE_DOCUMENT
    ? currentRoute.params.view : null;

  return {
    name: ROUTE_DOCUMENT,
    params: {
      id: link.documentId,
      view: paramView
    },
    hash: link.fragmentId ? '#' + link.fragmentId : ''
  };
};

export default {
  methods: {
    /**
     * @param {EventTarget} rootElem
     * @param {?Function<string>} [contextDocumentIdGetter]
     * @returns {void}
     */
    initNormaCsLinkHandler(rootElem, contextDocumentIdGetter = null) {
      rootElem.addEventListener('click', event => {
        let linkElem = getClosestLink(event.target);
        if (!linkElem  || linkElem.getAttribute('id') === 'mainNormaCsLink' || 
            linkElem.getAttribute('id') === 'sideNormaCsLink') {
          return;
        }
        event.preventDefault();

        let link = new ApiNormaCsLink(
          linkElem.getAttribute('href'),
          contextDocumentIdGetter ? contextDocumentIdGetter() : null,
          this.$store.state.databaseIds
        );
        if (link.isLinkToDocument()) {
          let route = makeDocumentRoute(link, this.$route);

          if (event.ctrlKey) {
            window.open(this.$router.resolve(route).href);
          } else {
            this.$router.push(route);
          }
        } else if (
          linkElem.href.indexOf(locationBaseUrl) === 0 &&
          !event.ctrlKey
        ) {
          // Это внутренняя ссылка приложения и не нажата клавиша Ctrl.
          this.$router.push(linkElem.href.substr(locationBaseUrl.length - 1));
        } else {
          // Это внешняя ссылка или нажата клавиша Ctrl - открываем в новом окне.
          window.open(linkElem.href);
        }
      });

      rootElem.addEventListener('contextmenu', event => {
        let linkElem = getClosestLink(event.target);

        if (!linkElem  || linkElem.getAttribute('id') === 'mainNormaCsLink' || 
            linkElem.getAttribute('id') === 'sideNormaCsLink') {
          return;
        }

        let link = new ApiNormaCsLink(
          linkElem.getAttribute('href'),
          contextDocumentIdGetter ? contextDocumentIdGetter() : null,
          this.$store.state.databaseIds
        );

        if (link.isLinkToDocument()) {
          let routeParams = makeDocumentRoute(link, this.$route);
          linkElem.href =
            locationBaseUrl.slice(0, -1) +
            this.$router.resolve(routeParams).route.fullPath;
        }
      });
    }
  }
};
</script>
